import { render, staticRenderFns } from "./SwamtReport.vue?vue&type=template&id=a2ca5e7e&scoped=true"
import script from "./SwamtReport.vue?vue&type=script&lang=js"
export * from "./SwamtReport.vue?vue&type=script&lang=js"
import style0 from "./SwamtReport.vue?vue&type=style&index=0&id=a2ca5e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca5e7e",
  null
  
)

export default component.exports